export default {
	"defaults": {
		"levels": {}
	},
	"configProps": [
		"level",
		"levels",
		"next_level"
	]
}